import React, { useState, Suspense, useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Loader from "../component/Loader";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./publicRoute";
import JobApplyRoute from "./JobApplyRoute";
import AdminRoute from "./adminRoute";
import SignupFacility from "views/authentication/signUpFacility/SignUpFacality";
import SignupClinician from "views/authentication/signUpClinician/SignupClinician";
import FacilitySignUpSuccessful from "views/authentication/signUpFacility/SignUpSuccessful";
import ClinicianSignUpSuccessful from "views/authentication/signUpClinician/SignUpSuccessful";
import UserContext from "utils/context/UserContext";
import AuthContext from "utils/context/AuthContext";
import { isEmpty } from "radash";
import { api } from "api/Api";
import { GET_LOGIN_DATA_URL, REFRESH_TOKEN_URL } from "constants/ApiUrls";
import MainLayout from "layouts/mainLayout";
import { CLINICIAN_SIGNUP, FACILITY_SIGNUP, PATHTONODATAFOUND, RESPONSE_OK } from "constants/AppConstants";
import FullLayout from "layouts/fullLayout";
import NotificationsContext, { UnreadContext } from "utils/context/NotificationsContext";
import AdminClinicianAccountSetting from "views/admin/accountSettings/adminClinicianSettings/clinicianAccountSettings";
import AdminFacilityAccountSetting from "views/admin/accountSettings/adminFacilitySettings/facilityAccountSettings";
import AdminFacilityProfile from "component/userListing/adminFacilityProfile";
import SignupFinalStep from "views/authentication/signUpClinician/signupFinalStep";
import MixpanelService from "utils/mixpanel";
const Login = React.lazy(() => import("../views/authentication/login"));
const ForgotPassword = React.lazy(() => import("../views/authentication/forgotpassword"));
const ResetPassword = React.lazy(() => import("../views/authentication/resetPassword"));
const SaveSuccessfullPassword = React.lazy(() => import("../views/authentication/savesuccessfullpass"));
const ApproveApplicationFromEmail = React.lazy(() => import("../views/facility/approveApplicationFromEmail"));
const AcceptShiftInviteFromEmail = React.lazy(() => import("../views/clinician/acceptShiftInviteFromEmail"));
const JobApplyFromEmail = React.lazy(() => import("../views/clinician/jobApplyFromEmail"));
const Error = React.lazy(() => import("../views/authentication/error403"));
const Error404 = React.lazy(() => import("../views/authentication/error404"));
const ClinicianLanding = React.lazy(() => import("../views/others/home/clinicianLanding"));
const FacilityLanding = React.lazy(() => import("../views/others/home/facilityLanding"));
const LandingWithoutInsta = React.lazy(() => import("../views/others/home/landingWithoutInsta"));
const Faq = React.lazy(() => import("../views/others/faq/faq"));
const PrivacyPolicy = React.lazy(() => import("../views/others/privacypolicy/privacypolicy"));
const TermCondition = React.lazy(() => import("../views/others/termcondition/termcondition"));
const FacilityAccountSetting = React.lazy(() => import("../views/facility/accountSettings"));
const ClinicianAccountSetting = React.lazy(() => import("../views/clinician/accountSettings"));
const HireList = React.lazy(() => import("../views/others/hireStaff/hireStaffList"));
const ClinicianProfile = React.lazy(() => import("../views/clinician/profile"));
const AboutUs = React.lazy(() => import("../views/others/aboutUs"));
const OurLocation = React.lazy(() => import("../views/others/ourLocation"));
const ContactUs = React.lazy(() => import("../views/others/contactUs"));
const JobPostListing = React.lazy(() => import("../views/facility/jobPosting"));
const JobApplicantListing = React.lazy(() => import("../component/jobPosting/applicantList"));
const EditJobPosting = React.lazy(() => import("../views/others/editJobPosting/editjobposting"));
const EmailCapture = React.lazy(() => import("component/emailCapture/EmailCapture.js"));
const ChatProfile = React.lazy(() => import("../views/others/chatProfile/chatProfile"));
const JobBoard = React.lazy(() => import("../component/jobBoard/jobBoard"));
const Notification = React.lazy(() => import("../component/common/notification"));
const MyDashboard = React.lazy(() => import("../views/clinician/myDashboard/dashboard"));
const ClinicianJobProfile = React.lazy(() => import("../views/clinician/clinicianJobProfile"));
const ShiftInviteRedirect = React.lazy(() => import("../views/clinician/shiftInviteRedirect"));
const UserListing = React.lazy(() => import("../views/admin/users/userListing"));
const InvoiceListing = React.lazy(() => import("../views/admin/invoice/invoiceListing"));
const FacilityReviews = React.lazy(() => import("../views/admin/facilityReviews/facilityReviews"));
const JobPosts = React.lazy(() => import("../component/userListing/jobPost"));
const JobDetail = React.lazy(() => import("../component/userListing/jobDetail"));
const ConfirmedShift = React.lazy(() => import("../component/userListing/confirmedShifts"));
const Profile = React.lazy(() => import("../views/others/profile/profile/profile"));
const FacilityProfile = React.lazy(() => import("../views/facility/profile"));
const AdminClinicianProfile = React.lazy(() => import("views/admin/profiles/clinicianProfile"));
const StripeProfile = React.lazy(() => import("../views/clinician/myDashboard/stripeProfile/stripeProfile"));
const AdminAccountSetting = React.lazy(() => import("../views/admin/accountSettings/adminAccountSettings/adminAccountSettings"));
const VerficationCode = React.lazy(() => import("../views/authentication/VerificationForm"));

const NoData = React.lazy(() => import(PATHTONODATAFOUND));

const AppRouter = () => {
  const location = useLocation();
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(null);

  const [user, setInternalUser] = useState(null);

  const setUser = (userData) => {
    setInternalUser(userData);
  };

  useEffect(() => {
    if (user && Object.keys(user).length > 0 && user.id) {
      MixpanelService.identifyUser(user.id, user.email, user);
    } else if (user && Object.keys(user).length === 0) {
      MixpanelService.resetUser();
    }
  }, [user]);
  const [notifications, setNotifications] = useState({});
  const [unreads, setUnreads] = useState(0);
  const [isApiCalled, setIsApiCalled] = useState(false);

  useEffect(() => {
    let token = localStorage.getItem("purplePTAuthToken");
    if (isEmpty(user) && token && token.length) {
      getUserObj();
    } else {
      setIsApiCalled(true);
    }
    if (
      !isUserAuthenticated &&
      localStorage.getItem("purplePTAuthToken") &&
      localStorage.getItem("purplePTAuthToken").length
    ) {
      setIsUserAuthenticated(true);
    } else setIsUserAuthenticated(false);
  }, []);

  const getUserObj = async () => {
    await refreshToken();
    refreshTokenInterval();
    setIsApiCalled(true);
  };

  const refreshToken = async () => {
    try {
      let token = await api(REFRESH_TOKEN_URL, {});
      setUser(token.data.data);
      // Re-register email super property for returning users (page reload/refresh)
      MixpanelService.identifyUser(token?.data?.data?.id, token?.data?.data?.email, token?.data?.data);
      localStorage.setItem("purplePTAuthToken", token?.data?.data?.token || "");
      localStorage.setItem(
        "purplePTRefreshToken",
        token?.data?.data?.refreshToken || ""
      );
      localStorage.setItem("clinicianId", token?.data?.data?.clinicianId?.id || "");
      localStorage.setItem("facilityId", token?.data?.data?.facilityId?.id || "");
      localStorage.setItem("userId", token?.data?.data?.id || "");
      if (token?.data?.data?.roles) {
        localStorage.setItem("userRole", token.data.data.roles);
      }
      setIsUserAuthenticated(true);
    } catch (error) {
      localStorage.removeItem("purplePTAuthToken");
      localStorage.removeItem("purplePTRefreshToken");
      localStorage.removeItem("userRole");
      localStorage.removeItem("userId");
      localStorage.removeItem("2FA");
      setUser({});
      setIsUserAuthenticated(false);
    }
  };

  const refreshTokenInterval = () => {
    let id = localStorage.getItem("PURPTID");
    if (id) {
      clearInterval(id);
    }

    let timeOutId = setInterval(() => {
      refreshToken();
    }, 55 * 60000);

    localStorage.setItem("PURPTID", timeOutId);
  };

  // 2FA expiry check
  useEffect(() => {
  const check2FAExpiry = () => {
    try {
      const data = JSON.parse(localStorage.getItem("remember2FA"));
      if (!data) return;

      const now = Date.now();
      const expiryTime = 7 * 24 * 60 * 60 * 1000;

      if (now - data.timestamp > expiryTime) {

        localStorage.removeItem("remember2FA");
        localStorage.removeItem("purplePTAuthToken");
        localStorage.removeItem("purplePTRefreshToken");
        localStorage.removeItem("userRole");
        localStorage.removeItem("userId");
        localStorage.removeItem("2FA");
        localStorage.removeItem("deviceToken");
        localStorage.removeItem("deviceId");
        localStorage.removeItem("PURPTID");
        localStorage.removeItem("deviceId_purpleprnadmin@yopmail.com")
        setIsUserAuthenticated(false);
        setUser({});
        window.location.href = "/login";
      }
    } catch (err) {
      console.error("2FA expiry check failed", err);
    }
  };

  // Run immediately when component mounts
  check2FAExpiry();

  // Keep checking every 10 seconds
  const interval = setInterval(check2FAExpiry, 10000);

  return () => clearInterval(interval); // Cleanup interval on unmount
}, []);

//   const check2FAExpiry = () => {
//   try {
//     const data = JSON.parse(localStorage.getItem("remember2FA"));
//     if (!data) return;

//     const now = Date.now();
//     const sevenDays =  2 * 60 * 1000;
//     console.log("callll", now,  data.timestamp, sevenDays);
    
//     if (now - data.timestamp > sevenDays) {
//     console.log("inside callll ?>>>>>>>>>>>>>>");
//       // More than 7 days — logout
//       localStorage.removeItem("remember2FA");
//       localStorage.removeItem("purplePTAuthToken");
//       localStorage.removeItem("purplePTRefreshToken");
//       localStorage.removeItem("userRole");
//       localStorage.removeItem("userId");
//       localStorage.removeItem("2FA");
//       setIsUserAuthenticated(false);
//       setUser({});
//       // optional: remove any other related tokens
//       window.location.href = "/login"; // or use navigate("/login") if inside router
//     }
//   } catch (err) {
//     console.error("2FA expiry check failed", err);
//   }
// };


//   useEffect(() => {
//     check2FAExpiry();
//   }, []);


  return (
    <AuthContext.Provider
      value={{ isUserAuthenticated, setIsUserAuthenticated }}
    >
      <UserContext.Provider value={{ user, setUser, refreshTokenInterval }}>
        <NotificationsContext.Provider
          value={{ notifications, setNotifications }}
        >
          <UnreadContext.Provider value={{ unreads, setUnreads }}>
            <Suspense fallback={<Loader />}>
              {isApiCalled && (
                <Routes>
                  <Route
                    path="/"
                    // element={
                    //   <MainLayout>
                    //     <LandingWithoutInsta />
                    //   </MainLayout>
                    // }
                    element={
                      isUserAuthenticated && user.status === 'approved' && user.isApprovedByAdmin === true && user.roles === 'facility' && !new URLSearchParams(location.search).get("timesheetId") ? (
                        <Navigate to="/facility/shiftmanagement" />
                      ) : (
                          <MainLayout>
                         <LandingWithoutInsta />
                        </MainLayout>
                      )
                    }

                  />
                  <Route
                    path="/403"
                    exact
                    element={
                      <MainLayout>
                        <Error />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/no-data"
                    exact
                    element={
                      <MainLayout>
                        <NoData />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/qr"
                    exact
                    element={<Navigate to="/newsletter" />}
                  />
                  <Route
                    path="/email"
                    exact
                    element={<Navigate to="/newsletter" />}
                  />
                  <Route
                    path="/approve-application/:token"
                    exact
                    element={
                      <FullLayout>
                        <ApproveApplicationFromEmail />
                      </FullLayout>
                    }
                  />
                  {/* SCRUM-326: one-click Accept from the shift invite email (public, token-gated) */}
                  <Route
                    path="/accept-shift-invite/:token"
                    exact
                    element={
                      <FullLayout>
                        <AcceptShiftInviteFromEmail />
                      </FullLayout>
                    }
                  />
                  {/* Accept deep link from the shift invite email: login required, applies through job-apply */}
                  <Route
                    path="/job/apply"
                    exact
                    element={
                      <JobApplyRoute>
                        <JobApplyFromEmail />
                      </JobApplyRoute>
                    }
                  />
                  <Route
                    path="/newsletter"
                    exact
                    element={
                      <MainLayout>
                        <EmailCapture />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/facility"
                    exact
                    element={
                      <MainLayout>
                        <FacilityLanding />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/clinician"
                    exact
                    element={
                      <MainLayout>
                        <ClinicianLanding />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/faq"
                    exact
                    element={
                      <MainLayout>
                        <Faq />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/privacy"
                    exact
                    element={
                      <MainLayout>
                        <PrivacyPolicy />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/terms"
                    exact
                    element={
                      <MainLayout>
                        <TermCondition />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/contactus"
                    exact
                    element={
                      <MainLayout>
                        <ContactUs />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/aboutus"
                    exact
                    element={
                      <MainLayout>
                        <AboutUs />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/findus"
                    exact
                    element={
                      <MainLayout>
                        <OurLocation />
                      </MainLayout>
                    }
                  />
                  {/* Routes to show when not login */}
                  <Route
                    path="/login"
                    exact
                    element={
                      <PublicRoute fullLayout>
                        <Login />
                      </PublicRoute>
                    }
                  />
                  {/* <Route
                    path="/admin/verification"
                    exact
                    element={
                      <PublicRoute fullLayout>
                        <VerficationCode />
                      </PublicRoute>
                    }
                  /> */}
                  <Route
                    path="/password/forgot"
                    exact
                    element={
                      <PublicRoute fullLayout>
                        <ForgotPassword />
                      </PublicRoute>
                    }
                  />
                  <Route
                    path="/password/reset"
                    exact
                    element={
                      <PublicRoute fullLayout>
                        <ResetPassword />
                      </PublicRoute>
                    }
                  />
                  <Route
                    path="/password/changed"
                    exact
                    element={
                      <PublicRoute fullLayout>
                        <SaveSuccessfullPassword />
                      </PublicRoute>
                    }
                  />
                  <Route
                    path={FACILITY_SIGNUP}
                    exact
                    element={
                      <FullLayout>
                        <SignupFacility />
                      </FullLayout>
                    }
                  />
                  <Route
                    path="/facility/signup/success"
                    exact
                    element={
                      <PublicRoute fullLayout>
                        <FacilitySignUpSuccessful />
                      </PublicRoute>
                    }
                  />
                  <Route
                    path={CLINICIAN_SIGNUP + "/success"}
                    exact
                    element={
                      <PublicRoute fullLayout>
                        <ClinicianSignUpSuccessful />
                      </PublicRoute>
                    }
                  />
                  <Route
                    path={CLINICIAN_SIGNUP + "/finalStep"}
                    exact
                    element={
                      <FullLayout>
                        <SignupFinalStep />
                      </FullLayout>
                    }
                  />
                  <Route
                    path={CLINICIAN_SIGNUP}
                    exact
                    element={
                      <FullLayout>
                        <SignupClinician />
                      </FullLayout>
                    }
                  />
                  {/* facility routes */}
                  {/* {user && ROLE_FACILITY.includes(user.roles) && (
                <> */}
                  <Route
                    path="/facility/settings"
                    exact
                    element={
                      <PrivateRoute>
                        <FacilityAccountSetting />
                      </PrivateRoute>
                    }
                  />
                  {/* </>
              )} */}
                  <Route
                    path="/facility/clinicianprofile/:id"
                    exact
                    element={
                      <MainLayout>
                        <FacilityProfile />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/admin/facility/clinicianprofile/:id"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <AdminFacilityProfile />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/hire-staff"
                    exact
                    element={
                      <MainLayout>
                        <HireList />
                      </MainLayout>
                    }
                  />
                  {/* clinician routes */}
                  {/* {user && ROLE_CLINICIAN.includes(user.roles) && (
                <> */}
                  <Route
                    path="/clinician/profile"
                    exact
                    element={
                      <PrivateRoute>
                        <ClinicianProfile />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/clinician/settings"
                    exact
                    element={
                      <PrivateRoute>
                        <ClinicianAccountSetting />
                      </PrivateRoute>
                    }
                  />
                  {/* </>
              )} */}
                  <Route
                    path="/clinician/jobboard"
                    exact
                    element={
                      <MainLayout>
                        <JobBoard />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/clinician/jobprofile/:id"
                    exact
                    element={
                      <MainLayout>
                        <ClinicianJobProfile />
                      </MainLayout>
                    }
                  />
                  {/* SCRUM-326: "Accept" link in the shift invite email -> shift details with the accept confirmation */}
                  <Route
                    path="/clinician/shift-invite/:id"
                    exact
                    element={<ShiftInviteRedirect />}
                  />
                  <Route
                    path="/clinician/dashboard"
                    exact
                    element={
                      <MainLayout>
                        <MyDashboard />
                      </MainLayout>
                    }
                  />
                  {/* admin routes */}
                  {/* {user && ROLE_ADMIN.includes(user.roles) && (
                <> */}
                  <Route
                    path="/facility/shiftmanagement"
                    exact
                    element={
                      <MainLayout>
                        <JobPostListing />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/admin/users"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <UserListing />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/verification"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <VerficationCode />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/cliniciandetails/:id"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <AdminClinicianAccountSetting />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/clinicianprofile/:id"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <AdminClinicianProfile />
                      </AdminRoute>
                    }
                  />
                  {/* </>
              )} */}
                  <Route
                    path="/admin/jobs"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <JobPosts />
                      </AdminRoute>
                    }
                  />

                  <Route
                    path="/admin/shifts"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <ConfirmedShift />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/invoice"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <InvoiceListing />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/facility-reviews"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <FacilityReviews />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/notifications"
                    exact
                    element={
                      // Notifications now live as a tab in Admin Account Settings.
                      <Navigate to="/admin/settings" state={{ tab: "5" }} replace />
                    }
                  />

                  <Route
                    path="/admin/facilitydetails/:id"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <AdminFacilityAccountSetting />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/settings"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <AdminAccountSetting />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    exact
                    element={
                      <MainLayout>
                        <Profile />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/facility/applicants"
                    exact
                    element={
                      <MainLayout>
                        <JobApplicantListing />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/facility/jobprofile/:id"
                    exact
                    element={
                      <MainLayout>
                        <EditJobPosting />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/chat-profile"
                    exact
                    element={
                      <MainLayout>
                        <ChatProfile />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/notifications"
                    exact
                    element={
                      <MainLayout>
                        <Notification />
                      </MainLayout>
                    }
                  />
                  <Route
                    path="/admin/jobdetails/:id"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <StripeProfile />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/jobdetail/:id"
                    exact
                    element={
                      <AdminRoute adminLayout>
                        <JobDetail />
                      </AdminRoute>
                    }
                  />
                  {/* {user &&
                (isUserAuthenticated === true ||
                  isUserAuthenticated === false) && ( */}
                  <Route path="*" exact element={<Error404 />} />
                  {/* )} */}
                </Routes>
              )}
            </Suspense>
          </UnreadContext.Provider>
        </NotificationsContext.Provider>
      </UserContext.Provider>
    </AuthContext.Provider>
  );
};

export default AppRouter;
